export declare type Compile = {
    watch: any;
};
